import { render, staticRenderFns } from "./checkbox.vue?vue&type=template&id=b759f494&"
import script from "./checkbox.vue?vue&type=script&lang=js&"
export * from "./checkbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b759f494')) {
      api.createRecord('b759f494', component.options)
    } else {
      api.reload('b759f494', component.options)
    }
    module.hot.accept("./checkbox.vue?vue&type=template&id=b759f494&", function () {
      api.rerender('b759f494', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "themes/default/src/components/checkbox/checkbox.vue"
export default component.exports